import { useQuery } from '@tanstack/react-query';
import { agentMetricsApi } from './agent-metrics.api';
import type { DailyStats, WeeklyTierStats } from '@/types/api';

export const DAILY_KEY = ['agents', 'me', 'today'] as const;
export const TIER_KEY = ['agents', 'me', 'tier'] as const;

export function useDailyStats() {
  return useQuery<DailyStats>({
    queryKey: DAILY_KEY,
    queryFn: agentMetricsApi.today,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
    refetchInterval: 60_000,
  });
}

export function useWeeklyTier() {
  return useQuery<WeeklyTierStats>({
    queryKey: TIER_KEY,
    queryFn: agentMetricsApi.tier,
    staleTime: 60_000,
    refetchOnWindowFocus: true,
  });
}

export const UPLOAD_STATUS_KEY = ['agents', 'me', 'upload-status'] as const;

export function useMyUploadStatus() {
  return useQuery({
    queryKey: UPLOAD_STATUS_KEY,
    queryFn: agentMetricsApi.uploadStatus,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
    refetchInterval: 60_000,
  });
}
